"use client";

import { useLang } from "@/providers/langProvider";
import { getTranslation } from "./getTranslation";
//use this in client component for translations
export const useTranslation = () => {
  const lang = useLang();

  return getTranslation(lang);
};
